import { lazy, Suspense, useEffect } from 'react';
import { Route, Routes } from 'react-router';
import { Layout } from './ui/components/Layout';
import { HomePage } from './ui/pages/HomePage';
import { NotFoundPage } from './ui/pages/NotFoundPage';
import { useSettings } from './store/settings';
import { SIM_MODE } from './env';
import { useT } from './ui/i18n';
import { bootstrap } from './bootstrap';
import { ErrorBoundary } from './ui/components/ErrorBoundary';

// Pages load on demand: three.js, Leaflet, uPlot and the FIT SDK stay out of the start bundle.
const RideScreen = lazy(() => import('./ui/pages/RideScreen').then((m) => ({ default: m.RideScreen })));
const WorkoutEditorPage = lazy(() =>
  import('./ui/pages/WorkoutEditorPage').then((m) => ({ default: m.WorkoutEditorPage })),
);
const CalendarPage = lazy(() => import('./ui/pages/CalendarPage').then((m) => ({ default: m.CalendarPage })));
const RoutesPage = lazy(() => import('./ui/pages/RoutesPage').then((m) => ({ default: m.RoutesPage })));
const RideSummaryPage = lazy(() =>
  import('./ui/pages/RideSummaryPage').then((m) => ({ default: m.RideSummaryPage })),
);
const GroupPage = lazy(() => import('./ui/pages/GroupPage').then((m) => ({ default: m.GroupPage })));
const BleDebugPage = lazy(() => import('./ui/pages/BleDebugPage').then((m) => ({ default: m.BleDebugPage })));
const RidesPage = lazy(() => import('./ui/pages/RidesPage').then((m) => ({ default: m.RidesPage })));
const WorkoutsPage = lazy(() => import('./ui/pages/WorkoutsPage').then((m) => ({ default: m.WorkoutsPage })));
const SettingsPage = lazy(() => import('./ui/pages/SettingsPage').then((m) => ({ default: m.SettingsPage })));
const DevicesPage = lazy(() => import('./ui/pages/DevicesPage').then((m) => ({ default: m.DevicesPage })));
const RideSetupPage = lazy(() =>
  import('./ui/pages/RideSetupPage').then((m) => ({ default: m.RideSetupPage })),
);

export function App() {
  const loaded = useSettings((s) => s.loaded);
  const t = useT();

  useEffect(() => {
    void bootstrap();
  }, []);

  if (!loaded) return <div className="main dim">{t('common.loading')}</div>;

  return (
    <>
      <Suspense fallback={<div className="main dim">{t('common.loading')}</div>}>
        <Routes>
          <Route
            path="/fahren/live"
            element={
              <ErrorBoundary>
                <RideScreen />
              </ErrorBoundary>
            }
          />
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="geraete" element={<DevicesPage />} />
            <Route path="fahren" element={<RideSetupPage />} />
            <Route path="workouts" element={<WorkoutsPage />} />
            <Route path="workouts/:id" element={<WorkoutEditorPage />} />
            <Route path="kalender" element={<CalendarPage />} />
            <Route path="routen" element={<RoutesPage />} />
            <Route path="fahrten" element={<RidesPage />} />
            <Route path="fahrten/:id" element={<RideSummaryPage />} />
            <Route path="gruppenfahrt" element={<GroupPage />} />
            <Route path="join/:code" element={<GroupPage />} />
            <Route path="einstellungen" element={<SettingsPage />} />
            <Route path="debug/ble" element={<BleDebugPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Suspense>
      {SIM_MODE && <div className="sim-banner">{t('misc.simBanner')}</div>}
    </>
  );
}
